import { render, staticRenderFns } from "./TransferStatusesCompanyWidget.vue?vue&type=template&id=f7b40994&scoped=true&"
import script from "./TransferStatusesCompanyWidget.vue?vue&type=script&lang=js&"
export * from "./TransferStatusesCompanyWidget.vue?vue&type=script&lang=js&"
import style0 from "./TransferStatusesCompanyWidget.vue?vue&type=style&index=0&id=f7b40994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b40994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7b40994')) {
      api.createRecord('f7b40994', component.options)
    } else {
      api.reload('f7b40994', component.options)
    }
    module.hot.accept("./TransferStatusesCompanyWidget.vue?vue&type=template&id=f7b40994&scoped=true&", function () {
      api.rerender('f7b40994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/TransferStatusesCompanyWidget.vue"
export default component.exports